<section class="page">
  <div class="container">
    <div class="page-wrapper">
      <div class="page-header">
        <h1 class="page-title">Editar usuário</h1>
        <div class="page-header__buttons">
          <mat-slide-toggle
            (change)="onSituacaoChange($event)"
            [checked]="data.situacao == 'A' ? true : false"
          >
            Situação:
            {{ data.situacao == "A" ? "Ativo" : "Inativo" }}</mat-slide-toggle
          >
          <button
            mat-stroked-button
            color="primary"
            routerLink="/imobiliaria/usuarios"
          >
            VOLTAR
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="openPasswordDialog()"
          >
            ALTERAR SENHA
          </button>
        </div>
      </div>
      <form class="page-form" (ngSubmit)="submit(form)" #form="ngForm">
        <h3 class="page-form__title">Dados do usuário</h3>

        <mat-form-field class="page-form-control">
          <input
            matInput
            type="text"
            placeholder="Nome"
            [(ngModel)]="data.nome"
            name="nome"
            required
          />
        </mat-form-field>

        <mat-form-field class="page-form-control">
          <input
            matInput
            type="email"
            [pattern]="helper.emailRegex"
            placeholder="E-mail"
            [(ngModel)]="data.email"
            name="email"
            required
          />
        </mat-form-field>

        <mat-form-field class="page-form-control">
          <input
            matInput
            type="tel"
            placeholder="Whatsapp"
            [(ngModel)]="data.whatsapp"
            name="whatsapp"
            (ngModelChange)="changePhoneMask($event)"
            [mask]="phoneMask"
            required
          />
        </mat-form-field>

        <mat-form-field class="page-form-control">
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Senha"
            [(ngModel)]="data.senha"
            name="senha"
            readonly
            required
          />
          <button
            mat-icon-button
            mat-button
            (click)="showPassword = !showPassword"
            matSuffix
            type="button"
          >
            <mat-icon>{{
              showPassword ? "visibility" : "visibility_off"
            }}</mat-icon>
          </button>
        </mat-form-field>

        <hr />

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="loadingService.active"
        >
          SALVAR
        </button>
      </form>
    </div>
  </div>
</section>
